import {useAuthenticationContext} from "../contexts/authenticationcontext";
import {Container, Nav, Navbar, NavDropdown, NavItem, NavLink} from "react-bootstrap";
import {IfLoggedIn, IfNotLoggedIn} from "./ifLoggedIn";
import {Navigate, Outlet, useNavigate} from "react-router-dom";

export function NavbarDefault() {
    const {logout, username, role} = useAuthenticationContext();
    const navigate = useNavigate();
    return <>
        <Navbar expand="lg" className="bg-dark navbar-dark bg-nav ">
            <Container >
                <Navbar.Brand href="/">

                    <img
                        src="/logonavbar.png"
                        width="80"

                        className="d-inline-block align-top"
                        alt="React Bootstrap logo"
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse  id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <NavDropdown title="VBFlw" id="basic-nav-dropdown">
                            <NavDropdown.Item href="/">Nieuws</NavDropdown.Item>
                            <IfLoggedIn>
                                <NavDropdown.Item href="/administratie">
                                    Administratief
                                </NavDropdown.Item>
                            </IfLoggedIn>
                            <NavDropdown.Item href="/verzekeringen">Verzekeringen</NavDropdown.Item>

                            <NavDropdown.Item href="/gedragscodes">
                                Gedragscodes
                            </NavDropdown.Item>
                        </NavDropdown>
                        <NavDropdown title="Competitie" id="basic-nav-dropdown">
                            <NavDropdown.Item href="/reglement">Reglement</NavDropdown.Item>
                            <NavDropdown.Item href="/resultaten">
                                Resultaten
                            </NavDropdown.Item>

                        </NavDropdown>
                        <NavDropdown title="Media" id="basic-nav-dropdown">
                            <NavDropdown.Item href="/fotos">Foto's</NavDropdown.Item>
                            <NavDropdown.Item href="/tijdschrift">
                                Tijdschrift
                            </NavDropdown.Item>
                        </NavDropdown>
                        <NavLink title={'Kalender'} href={'/kalender'} className={'nav-link'}>
                            Kalender
                        </NavLink>
                        <IfLoggedIn>
                            <Navbar.Text>Welkom {username}</Navbar.Text>
                            {role === "ROLE_ADMIN" ?
                                <Nav.Link className={"ms-2"} href={"/admindashboard"}>Admindashboard</Nav.Link> : ""}

                            <Nav.Link className={"ms-2"} onClick={() => {
                                logout();
                                navigate('/');
                            }}>Logout</Nav.Link>
                        </IfLoggedIn>
                        <IfNotLoggedIn>
                            <Nav.Link href="/login">Login</Nav.Link>
                            <Nav.Link href="/register">Registreer</Nav.Link>
                        </IfNotLoggedIn>
                        <NavDropdown title="Contact" id="basic-nav-dropdown">
                            <NavDropdown.Item href="/algemeenbestuur">Algemeenbestuur</NavDropdown.Item>
                            <NavDropdown.Item href="/technischdirectie">Techisch directie comite</NavDropdown.Item>
                            <NavDropdown.Item href="/clubs">
                                Clubs
                            </NavDropdown.Item>
                            <NavDropdown.Item href="/sectors">Sectors</NavDropdown.Item>
                            <NavDropdown.Item href="/vertrouwenspersoon">Vertrouwens persoon</NavDropdown.Item>
                            <NavDropdown.Item href="/bondsdokter">Bondsdokter</NavDropdown.Item>
                        </NavDropdown>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
        <Outlet/>
    </>
}